const linkOpener = url => {
  var win = window.open(url, '_blank')
  win.focus()
}

export default linkOpener
